import { ALLERGEN_OPTIONS, labelForAllergen } from "@/lib/allergens";

export function AllergenPicker({ value = [], onChange, testIdPrefix = "allergen" }) {
  const toggle = (key) => {
    const set = new Set(value);
    if (set.has(key)) set.delete(key); else set.add(key);
    onChange(Array.from(set));
  };
  return (
    <div className="flex flex-wrap gap-1.5">
      {ALLERGEN_OPTIONS.map((a) => {
        const on = value.includes(a.key);
        return (
          <button
            key={a.key}
            type="button"
            onClick={() => toggle(a.key)}
            data-testid={`${testIdPrefix}-${a.key}`}
            className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${
              on
                ? "bg-foreground text-background border-foreground"
                : "border-border text-muted-foreground hover:border-foreground/50"
            }`}
          >
            {a.label}
          </button>
        );
      })}
    </div>
  );
}

export function AllergenBadges({ allergens = [], size = "sm", testId = "recipe-allergens" }) {
  if (!allergens.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testId}>
      {allergens.map((a) => (
        <span
          key={a}
          className={`inline-flex items-center gap-1 rounded-full border gold-hair bg-primary/10 gold ${
            size === "sm" ? "text-[0.65rem] px-2 py-0.5" : "text-xs px-2.5 py-1"
          }`}
        >
          <span className="w-1 h-1 rounded-full bg-primary" />
          {labelForAllergen(a)}
        </span>
      ))}
    </div>
  );
}
